import React, { useState, useEffect } from "react";
import queryString from "query-string";

// services
import { Mixpanel, MixpanelEvents } from "../services/Mixpanel";

// seo
import Seo from "../components/Seo";

// utils
import { saveUTM } from "../utils";

// components
import Resources from "../components/Resources";

const ResourcePage = props => {
  const [depth25, setDepth25] = useState(true);
  const [depth50, setDepth50] = useState(true);
  const [depth75, setDepth75] = useState(true);
  const [depth100, setDepth100] = useState(true);
  const [deviceType, setDeviceType] = useState(""); // To store the device type

  // Save utm to local storage
  useEffect(() => {
    if (props.location.search) {
      saveUTM(props.location.search);
    }
  }, [props.location.search]);

  useEffect(() => {
    let loadTime =
      window.performance.timing.domContentLoadedEventEnd -
        window.performance.timing.navigationStart || 700;

    let utmParams = queryString.parse(props.location.search);

    // Mixpanel Event
    Mixpanel.track(MixpanelEvents.page_viewed, {
      page_name: "Resources Page",
      asset: "India Website",
      asset_name: "India Corporate Website",
      load_time: loadTime,
      campaign_id: utmParams.campaignid,
      device_type: deviceType,
    });
  }, [props.location.search, deviceType]);

  useEffect(() => {
    const handleScroll = () => {
      const pageYOffset = window.pageYOffset;
      const height = document.body.scrollHeight - window.innerHeight;
      const progress = Math.round((pageYOffset / height) * 100);

      if (progress === 25 && depth25) {
        Mixpanel.track(MixpanelEvents.page_depth_viewed, {
          page_name: "Resources Page",
          asset: "India Website",
          asset_name: "India Corporate Website",
          page_depth: progress,
        });
        setDepth25(false);
      } else if (progress === 50 && depth50) {
        Mixpanel.track(MixpanelEvents.page_depth_viewed, {
          page_name: "Resources Page",
          asset: "India Website",
          asset_name: "India Corporate Website",
          page_depth: progress,
        });
        setDepth50(false);
      } else if (progress === 75 && depth75) {
        Mixpanel.track(MixpanelEvents.page_depth_viewed, {
          page_name: "Resources Page",
          asset: "India Website",
          asset_name: "India Corporate Website",
          page_depth: progress,
        });
        setDepth75(false);
      } else if (progress === 100 && depth100) {
        Mixpanel.track(MixpanelEvents.page_depth_viewed, {
          page_name: "Resources Page",
          asset: "India Website",
          asset_name: "India Corporate Website",
          page_depth: progress,
        });
        setDepth100(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [depth25, depth50, depth75, depth100]);

  // Find The Device Type Of The User
  useEffect(() => {
    // Function to update device type based on screen width
    const updateDeviceType = () => {
      const width = window.innerWidth;
      if (width <= 768) {
        setDeviceType("Mobile");
      } else if (width <= 1024) {
        setDeviceType("Tablet");
      } else {
        setDeviceType("Desktop");
      }
    };

    // Update device type when the component mounts
    updateDeviceType();

    // Add an event listener to update device type when the window is resized
    window.addEventListener("resize", updateDeviceType);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", updateDeviceType);
    };
  }, []);

  // To Track Mixpanel Event When User Leave Page
  useEffect(() => {
    const handlePageExit = event => {
      Mixpanel.track(MixpanelEvents.page_exit, {
        page_name: "Resources Page",
        asset: "India Website",
        asset_name: "India Corporate Website",
      });
    };

    window.addEventListener("beforeunload", handlePageExit);

    return () => {
      window.removeEventListener("beforeunload", handlePageExit);
    };
  }, []);

  // Mixpanel Events -> Resource CTA Click events
  const handleResourceCTA = (resourceTitle, resourceCategory) => {
    Mixpanel.track(MixpanelEvents.resource_cta_clicked, {
      page_name: "Resources Page",
      asset: "India Website",
      asset_name: "India Corporate Website",
      cta_text: "Read More",
      cta_location: "Resources Page - " + resourceTitle,
      resource_category: resourceCategory,
    });
  };

  return (
    <>
      <Seo
        title="Twin Health India | Research, Press & Publications"
        description="Explore the publications, press and research studies behind Twin Health India and see the real proof behind our work in metabolic health."
      />
      <Resources onCtaClick={handleResourceCTA} />
    </>
  );
};

export default ResourcePage;
